import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Stage } from 'utils/types';

import c from '../utils/constants';
import { stageTransformer } from '../transformer';

export default function useGetStages(id?: string | null) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useQuery({
    queryKey: [c.PIPELINES, c.STAGES, id],
    queryFn: async () => {
      const api = new Api(args);

      const data: { data: Stage[] } = await api.get(
        await withAcl({
          account: {
            url: `api/v1/sales/pipelines/${id}/stages`,
            transformer: stageTransformer.stages,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/sales/pipelines/${id}/stages`,
            transformer: stageTransformer.stages,
          },
        }),
      );

      return data?.data;
    },
    enabled: !!id,
  });
}
